import React from "react";
import parse from "html-react-parser";
import routes from "../../../../app/routes";
import axios from "axios";

export default function TaskItem({
  id,
  date,
  title,
  description,
  linkTitle,
  linkUrl,
  removeTask,
  ...props
}) {
  const closeTask = (id) => {
    if (id != undefined) {
      axios.post(routes.api.required_actions.complete(id)).then((resp) => {
        removeTask(id);
      });
    }
  };

  return (
    <>
      <div>{date}</div>
      <div className="mt5">
        <div className="green bold">{title}</div>
        {description && <p>{parse(description)}</p>}
        <div className="mt5">
          {linkUrl != '' && (
          <a
            href={linkUrl}
            onClick={() => closeTask(id)}
            target="_blank"
            className="blue"
          >
            {linkTitle}
          </a>
          )}
        </div>
      </div>
    </>
  );
}
